import { render, staticRenderFns } from "./rcd-list.vue?vue&type=template&id=c2168022&scoped=true&"
import script from "./rcd-list.vue?vue&type=script&lang=js&"
export * from "./rcd-list.vue?vue&type=script&lang=js&"
import style0 from "./rcd-list.vue?vue&type=style&index=0&id=c2168022&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2168022",
  null
  
)

export default component.exports